module.exports = __webpack_public_path__ + "img/product_sk-ii_5@2x.526405ae.png";